module.exports = __webpack_public_path__ + "img/step-3.2c22a9d2.svg";